exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".component-single-characters-textbox .character-input{width:60px;height:75px;border:1px solid #eaeaeb;font-size:48px;text-transform:uppercase;text-align:center;border-radius:0;font-family:ProximaNova;margin:0}.component-single-characters-textbox .character-input::placeholder{color:#ddd}.component-single-characters-textbox .character-input:focus-visible{border-radius:0;border-color:#1e88e5;outline:#1e88e5}.component-single-characters-textbox.error .character-input{border-color:#ff553d;color:#ff553d}", ""]);

// exports
